/* Warmith cart-drawer upsell button. One delegated listener (survives Horizon's drawer morphs).
   data-lines = Shopify.actions.updateCart lines: remove current Warmith lines + add the cheapest bundle mix. */
(function () {
  if (window.__hcUpsell) return; window.__hcUpsell = true;
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest && e.target.closest('[data-hc-upsell-btn]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var box = btn.closest('[data-hc-upsell]'); var err = box && box.querySelector('.hc-up__err');
    var lines; try { lines = JSON.parse(btn.dataset.lines); } catch (x) { return; }
    btn.disabled = true; btn.classList.add('is-loading'); if (err) err.hidden = true;
    try {
      if (window.Shopify && Shopify.actions && Shopify.actions.updateCart) {
        var res = await Shopify.actions.updateCart({ lines: lines }, { event: { context: 'cart' } });
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
      } else {
        // Fallback: AJAX cart API, then reload so every cart UI is consistent.
        var updates = {};
        lines.forEach(function (l) { if (l.id) updates[l.id] = 0; });
        var r1 = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
        if (!r1.ok) throw new Error('update');
        var items = lines.filter(function (l) { return l.merchandiseId; }).map(function (l) { return { id: Number(String(l.merchandiseId).split('/').pop()), quantity: l.quantity }; });
        var r2 = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
        if (!r2.ok) throw new Error('add');
        location.reload(); return;
      }
    } catch (x) {
      if (err) err.hidden = false;
      console.warn('[hc-upsell]', x);
    } finally {
      btn.disabled = false; btn.classList.remove('is-loading');
    }
  });
})();
